export default function ToggleButton({ status, action, itemId, email }) {
    return(
        <button className={`toggle-btn ${ status ? 'active': '' }`}  onClick={() => action( itemId, status, email )}>
            <span></span>
        </button>
    )
}